import { render } from "./admin-revenue.vue?vue&type=template&id=45ccd3f4&scoped=true"
import script from "./admin-revenue.vue?vue&type=script&lang=js"
export * from "./admin-revenue.vue?vue&type=script&lang=js"

import "./admin-revenue.vue?vue&type=style&index=0&id=45ccd3f4&scoped=true&lang=css"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ccd3f4"]])

export default __exports__